import Constants from '../utils/params';

export function handleErrors(response)
{
    if (!response.ok) {
        throw (response);
    }
    return response.json();
}

export function getAuditById(token, id)
{
  let params = {
    headers: {'Authorization': "bearer " + token}
  };

  return fetch(`${Constants.DOMAIN}/api/audit/` + id, params)
  .then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
    return err;
  })
}

export function getAudits(token)
{
    let params = {
        headers: {'Authorization': "bearer " + token}
    };
    return fetch(`${Constants.DOMAIN}/api/audit/`, params)
        .then(handleErrors)
        .then(res=>{
            return res;
        })
        .catch((err)=>{
            return err;
        })
}

export function getArchives(token)
{
    let params = {
        headers: {'Authorization': "bearer " + token}
    };
    return fetch(`${Constants.DOMAIN}/api/audit/archives`, params)
        .then(handleErrors)
        .then(res=>{
            return res;
        })
        .catch((err)=>{
            return err;
        })
}

export function getAuditsCalendarEvents(token)
{
  let params = {
    headers: {'Authorization': "bearer " + token}
  };

  return fetch(`${Constants.DOMAIN}/api/audit/calendar`, params)
      .then(handleErrors)
      .then(res=>{
        return res;
      })
      .catch((err)=>{
        return err;
      })
}

export function getAuditsByStatus(token, status)
{
  let params = {
    headers: {'Authorization': "bearer " + token}
  };

  return fetch(`${Constants.DOMAIN}/api/audit/` + status, params)
  .then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
    return err;
  })
}

export function getAuditTypes(token)
{
  let params = {
    headers: {'Authorization': "bearer " + token}
  };

  return fetch(`${Constants.DOMAIN}/api/audit_type/`, params)
  .then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
    return err;
  })
}

export function createAudit(token, data)
{
  return fetch(`${Constants.DOMAIN}/api/audit/true`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "bearer " + token
    },
    body: JSON.stringify(data)
  }).then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
      throw(err)
  })
}

export function updateAudit(token, id, data)
{
  return fetch(`${Constants.DOMAIN}/api/audit/` + id, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "bearer " + token
    },
    body: JSON.stringify(data)
  }).then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
      throw(err)
  })
}

export function syncAudits(token, ids)
{
  return fetch(`${Constants.DOMAIN}/api/audit/sync/`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "bearer " + token
    },
    body: JSON.stringify({"audits" : ids})
  }).then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
    return err;
  })
}

export function removeAudit(token, id)
{
  return fetch(`${Constants.DOMAIN}/api/audit/` + id, {
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "bearer " + token
    }
  }).then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
      throw(err)
  })
}



// WEBPACK FOOTER //
// ./src/api/audit.js